module.exports = __webpack_public_path__ + "img/epr-article-top-img@2x.98a8185c.jpeg";